import React, { Component } from 'react';
import BaseRefer from './BaseRefer';
// import DropDownRefer from './DropDownRefer';
import DropDownRefer from './DropDownRefernew';

import PopRefer from './PopRefer';
import ReferWithUnit from './ReferWithUnit';
import ArrayTree from './components/ArrayTree';
import MultiLangWrapper from './MultiLangWrapper';
import ReferLoader from './ReferLoader';
import loadColumu, { columnAjax, configAjax, getItems } from './loadColumn';
import { ViewModel } from '@platform/api';

require('./index.less');

/**
 * @namespace Refer
 */

class Refer extends Component {
    render() {
        const { refType, type, unitProps } = this.props;
        if (type === 'dropDown' && refType === 'grid') {
            return <DropDownRefer {...this.props} />;
        } else if (unitProps) {
            return <ReferWithUnit {...this.props} />;
        } else {
            return <PopRefer {...this.props} />;
        }
    }
}

Refer = loadColumu(MultiLangWrapper(Refer));

/**
 * ReferWithUnitBridge: 继承 ReferWithUnit 并通过方法重写集成 loadColumn 逻辑。
 * 使其他开发通过 extends Refer.ReferWithUnit 继承时，
 * super.componentWillMount() 等生命周期调用仍指向 ReferWithUnit 父类，
 * 同时 loadColumn 的模板加载和参照配置逻辑会正常执行。
 */
class ReferWithUnitBridge extends ReferWithUnit {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            _lcReferConfig: {},
            _lcColumns: [],
            _lcPageid: '',
            _lcTs: '',
        };
        this._lcFirstFlag = false;
        this._lcLoadConfig = true;
        this._prevLcLoadConfig = true;

        // 保存父类 beforeEvent 引用（BaseRefer 中定义为箭头函数 = 实例属性）
        // 如果外层已有 loadColumn（如 ReferLoader 被 loadColumu 包装），
        // 会通过 props 传入 onBeforeFocus，此时桥接类跳过自身的 loadColumn 逻辑
        const _parentBeforeEvent = this.beforeEvent;
        this.beforeEvent = (onFocus, callback, event, options) => {
            if (!this.props.onBeforeFocus) {
                this._lcOnBeforeFocus();
            }
            return _parentBeforeEvent(onFocus, callback, event, options);
        };

        // 父类 loadTableData 等也是箭头函数（实例属性），无法用 super.xxx() 调用，
        // 需要在构造函数中保存引用后再覆盖
        const _parentLoadTableData = this.loadTableData;
        const _parentLoadTableDataSync = this.loadTableDataSync;
        const _parentUsualAction = this.usualAction;
        const _parentUsualCollectAction = this.usualCollectAction;

        this.loadTableData = async (param, useCache, loading) => {
            return this._withLcPageid(() => _parentLoadTableData(param, useCache, loading));
        };
        this.loadTableDataSync = (param, useCache, loading, useUsual) => {
            return this._withLcPageid(() => _parentLoadTableDataSync(param, useCache, loading, useUsual));
        };
        this.usualAction = async (action, pk, index, useStarFlag, rowpk) => {
            return this._withLcPageid(() => _parentUsualAction(action, pk, index, useStarFlag, rowpk));
        };
        this.usualCollectAction = async (action, pk, index, useStarFlag, rowpk) => {
            return this._withLcPageid(() => _parentUsualCollectAction(action, pk, index, useStarFlag, rowpk));
        };
    }

    // loadColumn 的 onBeforeFocus 逻辑
    _lcOnBeforeFocus = async () => {
        if (this._lcFirstFlag) { return; }
        this._lcFirstFlag = true;
        let { dataval = '', refcode = '', pk_defdoclist = '' } = this.props;
        if (dataval || refcode) {
            let data = ViewModel.getData(
                'REFER_TEMPLET' + dataval + refcode + pk_defdoclist,
            );
            if (data) {
                let items = getItems(data.data);
                let templet = data.data?.templet;
                this.setState({
                    _lcColumns: items,
                    _lcPageid: templet?.pageid,
                    _lcTs: templet?.ts,
                });
            } else {
                let params = {
                    refinfoid: dataval,
                    refcode: refcode,
                    pk_defdoclist,
                    compareTs: false,
                };
                let columnData = await columnAjax(params);
                ViewModel.setData('REFER_TEMPLET' + dataval + refcode + pk_defdoclist, { data: columnData });
                if (columnData) {
                    let items = getItems(columnData);
                    let templet = columnData?.templet;
                    this.setState({
                        _lcColumns: items,
                        _lcPageid: templet?.pageid,
                        _lcTs: templet?.ts,
                    });
                }
            }
        }
        if (dataval) {
            let data = ViewModel.getData(
                'REFER_CONFIG' + dataval + refcode,
            );
            if (data) {
                this.setState({ _lcReferConfig: data.data });
                this._lcLoadConfig = false;
            } else {
                let params = { refinfoid: dataval };
                let configData = await configAjax(params);
                ViewModel.setData('REFER_CONFIG' + dataval + refcode, { data: configData });
                this._lcLoadConfig = false;
                if (configData) {
                    this.setState({ _lcReferConfig: configData });
                }
            }
        } else {
            this._lcLoadConfig = false;
        }
    };

    // 合并模板列到 columnConfig（逻辑同 MultiLangWrapper.mergeColumn）
    _mergeLoadColumns = (columnConfig, items) => {
        let attrcodeArr = new Set(),
            labelArr = new Set(),
            widthMap = {},
            itemtypeMap = {},
            colorMap = {};
        items.forEach((item) => {
            let { attrcode, label, width = 150, visible, itemtype, contentcolor } = item;
            if (visible && !attrcodeArr.has(attrcode)) {
                attrcodeArr.add(attrcode);
                labelArr.add(label);
                widthMap[attrcode] = width;
                itemtypeMap[attrcode] = itemtype;
                colorMap[attrcode] = contentcolor;
            }
        });
        if (columnConfig && Array.isArray(columnConfig)) {
            columnConfig = columnConfig.map(
                ({ name, code, width, fullTxtCode, search, contentcolor }) => {
                    let column = {};
                    column.name = [...(name || []), ...labelArr];
                    column.code = [...(code || []), ...attrcodeArr];
                    column.width = Object.assign(width || {}, widthMap);
                    column.itemtype = Object.assign({}, itemtypeMap);
                    column.contentcolor = Object.assign(contentcolor || {}, colorMap);
                    search && (column.search = { ...search });
                    fullTxtCode && (column.fullTxtCode = { ...fullTxtCode });
                    return column;
                },
            );
        } else {
            columnConfig = [
                {
                    name: [...labelArr],
                    code: [...attrcodeArr],
                    width: widthMap,
                    itemtype: itemtypeMap,
                    contentcolor: colorMap,
                },
            ];
        }
        return columnConfig;
    };

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);

        // 模板列加载完成后合并到 columnConfig
        if (this.state._lcColumns !== prevState._lcColumns && this.state._lcColumns.length) {
            let columnConfig = typeof this.getColumnConfig === 'function'
                ? this.getColumnConfig()
                : this.state.columnConfig || this.props.columnConfig;
            columnConfig = this._mergeLoadColumns(columnConfig, this.state._lcColumns);
            this.setState({ columnConfig });
        }

        // loadConfig 变为 false 时触发初始化（同 BaseRefer.componentDidUpdate 逻辑）
        if (this._prevLcLoadConfig !== this._lcLoadConfig && !this._lcLoadConfig) {
            this._prevLcLoadConfig = this._lcLoadConfig;
            let { onFocus } = this.props;
            if (this.delayAutoShow) {
                this.delayAutoShow = false;
                this.beforeEvent(onFocus, this.show, {});
            } else if (this.delayShow) {
                this.delayShow = false;
                this.show();
            }
        }
    }

    // 以下方法重写：将 loadColumn 加载的 pageid/ts 注入请求参数
    // 父类方法内部从 this.props 解构 pageid/ts 后赋给 param，无法通过参数覆盖，
    // 所以在调用 super 前临时将值写入 this.props，调用完后恢复
    // 外层已有 loadColumn（如 ReferLoader）时，pageid/ts 已通过 props 传入，
    // 不需要桥接类再注入，直接调用 super 即可
    _withLcPageid(fn) {
        // 外层 loadColumn 已提供 pageid/ts，跳过注入
        if (this.props.onBeforeFocus) {
            return fn();
        }
        const origPageid = this.props.pageid;
        const origTs = this.props.ts;
        if (this.state._lcPageid !== undefined) {
            this.props.pageid = this.state._lcPageid;
        }
        if (this.state._lcTs !== undefined) {
            this.props.ts = this.state._lcTs;
        }
        try {
            return fn();
        } finally {
            this.props.pageid = origPageid;
            this.props.ts = origTs;
        }
    }

}

Refer.BaseRefer = BaseRefer;
Refer.DropDownRefer = DropDownRefer;
Refer.PopRefer = PopRefer;
Refer.ArrayTree = ArrayTree;
Refer.ReferWithUnit = ReferWithUnitBridge;
Refer.MultiLangWrapper = MultiLangWrapper;
Refer.ReferLoader = loadColumu(ReferLoader);

export default Refer;
